import { useState, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../Utils/api';

// VAPID Public Key corresponding to the backend
const VAPID_PUBLIC_KEY = 'BMhsNUhPlF303kRTV5ohKh8Iwx72SfJHQI4F4rF2SN2Ds0ZcbiJj2DCPqc1ph8xJ0lrrL9mPR2IHZWi7VdiF3Lo';

// Helper to convert base64 to Uint8Array required by Web Push
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function usePushNotifications() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [permission, setPermission] = useState(Notification.permission);
  const [loading, setLoading] = useState(false);

  const subscribeToPush = useCallback(async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('Push messaging is not supported');
      return false;
    }

    try {
      setLoading(true);
      
      // 1. Request Permission
      const permResult = await Notification.requestPermission();
      setPermission(permResult);
      if (permResult !== 'granted') {
        throw new Error('Permission denied');
      }

      // 2. Register Service Worker
      const registration = await navigator.serviceWorker.register('/sw.js');
      await navigator.serviceWorker.ready;

      // 3. Subscribe to PushManager
      const existingSubscription = await registration.pushManager.getSubscription();
      let subscription = existingSubscription;
      
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
      }

      // 4. Send Subscription to Backend
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/notifications/subscribe`, subscription, {
        headers: { Authorization: `Bearer${token}` }
      });

      setIsSubscribed(true);
      return true;
    } catch (err) {
      console.error('Error in subscribeToPush:', err);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    isSubscribed,
    permission,
    loading,
    subscribeToPush
  };
}
